module.exports = __webpack_public_path__ + "media/images/footer/pattern-way-6f7c342815983e4ffda56c07c508de8f.svg";